import React, { useContext } from 'react';
import styled from 'styled-components';
import { Text } from 'components';
import { formatCurrency } from 'utils';
import AppointmentDeskContext from '../../AppointmentDeskContext';

const AnsweringServiceInfo: React.FC = () => {
  const { portalConfig, subscriptionType, isBoardCovered } = useContext(
    AppointmentDeskContext,
  );
  if (!portalConfig) return null;

  const {
    answeringServiceName,
    brokeragePrice,
    agentPrice,
    appointmentDeskMlsPay,
  } = portalConfig;
  let price = subscriptionType === 'org' ? brokeragePrice : agentPrice;

  let descriptiveText =
    subscriptionType === 'org' ? 'per active listing per month' : 'per month';

  if (appointmentDeskMlsPay) {
    price = 0;
    descriptiveText =
      'The MLS is covering the cost of the Live Concierge Service';
  } else if (isBoardCovered) {
    price = 0;
    descriptiveText =
      'The association is covering the cost of the Live Concierge Service';
  }

  return (
    <>
      <StyledAnsweringName data-cy="appointmentDesk-info-name">
        {answeringServiceName}
      </StyledAnsweringName>
      <StyledAnsweringPrice strong data-cy="appointmentDesk-info-price">
        {formatCurrency(price / 100)}
      </StyledAnsweringPrice>
      <StyledSmallText
        type="secondary"
        data-cy="appointmentDesk-info-price-description"
      >
        {descriptiveText}
      </StyledSmallText>
    </>
  );
};

export default AnsweringServiceInfo;

const StyledAnsweringName = styled(Text)`
  font-size: 16px;
  line-height: 24px;
  margin: 24px;
`;

const StyledAnsweringPrice = styled(Text)`
  font-size: 38px;
  line-height: 46px;
`;

const StyledSmallText = styled(Text)`
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 24px;
`;
